export default __webpack_public_path__ + "static/media/edu-5.3303e4f0.jpg";